"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerItemDataRefFactoryFromJs = exports.ExplorerItemDataRefFactory = void 0;
const immutable_1 = require("immutable");
const ExplorerFileType_1 = require("./ExplorerFileType");
exports.ExplorerItemDataRefFactory = (0, immutable_1.Record)({
    name: null,
    extension: null,
    subType: ExplorerFileType_1.ExplorerFileType.Default,
    properties: null,
    locked: false,
    hidden: false,
    isLeaf: null,
    projectVersion: null,
    deployAgentId: null,
    buildAgentId: null,
    secretKey: null,
    useVersion: false,
    createNugetPackage: false,
    autoStartOnStartup: false,
    passKey: null
});
const ExplorerItemDataRefFactoryFromJs = function (data) {
    return (0, exports.ExplorerItemDataRefFactory)({
        name: data.name,
        extension: data.extension,
        subType: data.subType,
        locked: data.locked,
        hidden: data.hidden,
        properties: data.properties,
        isLeaf: data.isLeaf,
        projectVersion: data.projectVersion,
        deployAgentId: data.deployAgentId,
        buildAgentId: data.buildAgentId,
        secretKey: data.secretKey,
        useVersion: data.useVersion,
        createNugetPackage: data.createNugetPackage,
        autoStartOnStartup: data.autoStartOnStartup,
        passKey: data.passKey
    });
};
exports.ExplorerItemDataRefFactoryFromJs = ExplorerItemDataRefFactoryFromJs;
//# sourceMappingURL=IExplorerItemDataRef.js.map